import target_tip_img1 from "../assets/plan/equipment_head_1.png"
import target_tip_img2 from "../assets/plan/equipment_head_2.png"
import target_tip_img3 from "../assets/plan/equipment_head_3.png"
import target_tip_no_img1 from "../assets/plan/no_equipment_head_1.png"
import target_tip_no_img2 from "../assets/plan/no_equipment_head_2.png"
import target_tip_no_img3 from "../assets/plan/no_equipment_head_3.png"
import plan_target_tip1 from "../assets/plan/plan_target_tip1.png"
import plan_target_tip2 from "../assets/plan/plan_target_tip2.png"
import plan_target_tip3 from "../assets/plan/plan_target_tip3.png"


export default {
    plan_name_err2:'The name of the plan is limited to 30 characters!',
    plan_name_err1:'Please enter a name for your plan!',
    need_choose_data:'Please choose the weekdays to work out on!',
    need_choose_vote:"Please complete the form!",
    need_choose_calorie:"Please set your calorie!",
    customize_plan_target_tip1:plan_target_tip1,
    customize_plan_target_tip2:plan_target_tip2,
    customize_plan_target_tip3:plan_target_tip3,
    customize_target_tip1:target_tip_img1,
    customize_target_tip2:target_tip_img2,
    customize_target_tip3:target_tip_img3,
    customize_target_no_tip1:target_tip_no_img1,
    customize_target_no_tip1:target_tip_no_img2,
    customize_target_no_tip1:target_tip_no_img3,
}


// WEBPACK FOOTER //
// ./src/js/ai.js